<div style="width: 100%; position: relative">
  <rask-map [settings]="mapsettings" [refresh]="refresh" [filter]="filter">
    <rask-map-select geotypes="arbetsordrar"></rask-map-select>
    <rask-map-layers (visibilityEvent)="layerVisibilityChanged($event)"></rask-map-layers>
  </rask-map>
  <div class="legends">
    <rask-tpl-volym></rask-tpl-volym>
    @if (showArbetsorderLegend()) {
      <rask-tpl-legend [data]="legendData"></rask-tpl-legend>
    }
  </div>
  <div #popup [hidden]="!clickedItem.visible" class="popup" (click)="hideTooltip()">
    @if (!clickedItem.route) {
      <small>{{clickedItem.label}}</small>
    }
    @if (clickedItem && clickedItem.route && clickedItem.id) {
      <small>
        <a [routerLink]="[clickedItem.route, clickedItem.id]">
          <span>{{clickedItem.label}}</span>
        </a>
      </small>
    }
  </div>
</div>